import CoberturaEstoque from '@/components/Relatorios/Produtos/CoberturaEstoque';
import ExcessoDeEstoque from "@/components/Relatorios/Produtos/ExcessoDeEstoque";
import SugestaoDeCompra from "@/components/Relatorios/Compras/SugestaoDeCompra";
import AderenciaSugestaoCompra from "@/components/Relatorios/Compras/AderenciaSugestaoCompra.vue";
import ComparativoSugestaoCategoria from "@/components/Relatorios/Compras/ComparativoSugestaoCategoria";
import EstoqueFilialPorCurvasPQR from "@/components/Relatorios/Curvas/EstoqueFilialPorCurvasPQR";
import NoMoving from "@/components/Relatorios/Produtos/NoMoving";
import EstoqueAnaliseGerencial from "@/components/Relatorios/Produtos/EstoqueAnaliseGerencial.vue";
import SavingDeCompras from "@/components/Relatorios/Compras/SavingDeCompras";
import ProdutosPorFilial from "@/components/Relatorios/Produtos/ProdutosPorFilial";
import HistoricoDeVendas from "@/components/Relatorios/Saidas/HistoricoDeVendas";
import TotalCompradoPorFilial from "@/components/Relatorios/Compras/TotalCompradoPorFilial";
import ComprasTransito from "@/components/Relatorios/Compras/ComprasTransito.vue";
import AnaliseBalanceamento from "@/components/Relatorios/DRP/AnaliseBalanceamento.vue";
import ComparacaoDeEstoques from '@/components/Relatorios/Produtos/ComparacaoDeEstoques.vue';
import PontaDeEstoque from '@/components/Relatorios/Produtos/AnalisePorLotes/PontaDeEstoque.vue';
import PedidosPendentes from "@/components/Relatorios/Pedidos/PedidosPendentes.vue";
import ProdutosFatorConversao from "@/components/Relatorios/Produtos/ProdutosFatorConversao.vue";
import ProdutosDeCombinados from '@/components/Relatorios/Produtos/ProdutosDeCombinados.vue';
import RelatorioAvariaProdutosFilialPorData from '@/components/Relatorios/Produtos/RelatorioAvariaProdutosFilialPorData.vue';
import RelatorioRessuprimentoManual from '@/components/Relatorios/Fornecedores/RessuprimentoManual.vue';
import ComHeranca from './Produtos/ComHeranca.vue';
import BTRelatorioFrequenciaSaida from './Personalizados/BTRelatorioFrequenciaSaida.vue';
import ProdutosSugestaoCompra from "@/components/Relatorios/Compras/ProdutosSugestaoCompra.vue";
import ProdutosFatorAtuacao from "@/components/Relatorios/Compras/ProdutosFatorAtuacao.vue";
import ProdutosHeranca from "@/components/Relatorios/Compras/ProdutosHeranca.vue";

export const relatorios = {
  relatorio_cobertura_estoque: CoberturaEstoque,
  relatorio_excesso: ExcessoDeEstoque,
  "relatorios/sugestao-compras": SugestaoDeCompra,
  "relatorios/comparativo-sugestao-comprador": AderenciaSugestaoCompra,
  "relatorios/comparativo-sugestao-categoria": ComparativoSugestaoCategoria,
  "relatorios/estoque-filial-por-curvas-pqr": EstoqueFilialPorCurvasPQR,
  relatorio_no_moving: NoMoving,
  relatorio_analise_gerencial: EstoqueAnaliseGerencial,
  relatorio_compras_pedidos_saving: SavingDeCompras,
  "relatorios/produtos-por-filial": ProdutosPorFilial,
  "relatorios/historico-de-vendas": HistoricoDeVendas,
  "relatorios/compras/total-comprado-por-filial": TotalCompradoPorFilial,
  "relatorios/detalhamento/produtos-por-filial": ComprasTransito,
  "relatorios/drp/analise-balanceamento": AnaliseBalanceamento,
  "relatorios/comparacao-de-estoque": ComparacaoDeEstoques,
  "relatorios/analise-por-lotes/ponta-de-estoque": PontaDeEstoque,
  relatorio_pedidos_pendentes: PedidosPendentes,
  "relatorios/produtos-fator-conversao": ProdutosFatorConversao,
  "relatorios/produtos-de-combinados": ProdutosDeCombinados,
  "relatorios/avaria-produtos-filial-por-data": RelatorioAvariaProdutosFilialPorData,
  relatorio_ressuprimento: RelatorioRessuprimentoManual,
  'relatorios/produtos/com-heranca': ComHeranca,
  'relatorios/personalizados/bt-relatorio-frequencia-saida': BTRelatorioFrequenciaSaida,
  relatorio_produtos_sugestao_compra: ProdutosSugestaoCompra,
  relatorio_produtos_fator_atuacao: ProdutosFatorAtuacao,
  relatorio_produtos_heranca: ProdutosHeranca
}

